<!-- Custom menu -->

<div class="tg-main" [class.collapsed]="collapsed">
  <div class="tg-menu_head">
    <div class="logo" *ngIf="!collapsed">
      <img
        src="/assets/images/logo-new.svg"
        alt="Logo"
        class="logo-img img-fluid mr-2"
      />
    </div>
    <button
      type="button"
      class="collapse-toggle"
      (click)="toggleCollapse.emit()"
      [attr.aria-label]="collapsed ? 'Expand menu' : 'Collapse menu'"
    >
      <span class="chevron" [class.expanded]="!collapsed"></span>
    </button>
  </div>
  <div class="tg-menu_body">
    <ul ngbNav class="main-menu" orientation="vertical">
      <li [ngbNavItem]="entry.route" *ngFor="let entry of entries">
        <a
          ngbNavLink
          [routerLink]="entry.route"
          [routerLinkActive]="['active']"
          [class.active]="navLinkActive(entry.route)"
          [attr.title]="collapsed ? (entry.label | translate) : null"
        >
          <img
            [src]="
              !router.url.includes(entry.route)
                ? '/assets/images/menu/' + entry.icon + '.svg'
                : '/assets/images/menu/' + entry.icon + '-active.svg'
            "
            alt="Profile Icon"
            class="img-fluid menu-icon"
          />
          <span class="menu-label">{{ entry.label | translate }}</span>
        </a>
      </li>
    </ul>
  </div>
  <div class="tg-menu_footer">
    <ul ngbNav class="bottom-menu" orientation="vertical">
      <li *ngIf="isGym && hasGymPermission" [ngbNavItem]="'/settings'">
        <a
          ngbNavLink
          [routerLink]="'/settings'"
          [class.active]="router.url.includes('/settings')"
          [attr.title]="
            collapsed ? (TranslationEnum.Menu.SETTINGS | translate) : null
          "
        >
          <img
            [src]="
              !router.url.includes('/settings')
                ? '/assets/images/menu/settings.svg'
                : 'assets/images/menu/settings-active.svg'
            "
            alt="Profile Icon"
            class="img-fluid menu-icon"
          />
          <span class="menu-label">{{
            TranslationEnum.Menu.SETTINGS | translate
          }}</span>
        </a>
      </li>
    </ul>
  </div>
</div>
